export class Slider {
	/**
	 *
	 * @param {HTMLElement} node - the node that contains the root scrolling element
	 * @param {Object}      opts - the options for the slider
	 */
	constructor( node, opts ) {
		this.node = node;
		this.opts = {
			prev: '.card-slider__nav-btn--prev',
			next: '.card-slider__nav-btn--next',
			content: '.card-slider__content',
			items: '.card-slider__content > *',
			...opts,
		};

		if ( ! this.node ) {
			return;
		}

		this.querySelectors();

		window.addEventListener( 'resize', this.setState.bind( this ) );

		this.content.addEventListener( 'scroll', this.setState.bind( this ), { passive: true } );
		this.next.addEventListener( 'click', this.nextIndex.bind( this ) );
		this.prev.addEventListener( 'click', this.prevIndex.bind( this ) );

		this.setState();
	}

	querySelectors() {
		this.prev = this.node.querySelector( this.opts.prev );
		this.next = this.node.querySelector( this.opts.next );
		this.content = this.node.querySelector( this.opts.content );
		this.items = this.node.querySelectorAll( this.opts.items );

		if ( ! this.prev || ! this.next ) {
			// eslint-disable-next-line no-console
			console.warn( 'Slider navigation buttons not found' );
		}
	}

	setState() {
		// check if we can scroll to previous
		this.prev.disabled = this.content.scrollLeft <= 1;

		// check if we can scroll to next
		const maxScrollLeft = this.content.scrollWidth - this.content.offsetWidth;
		this.next.disabled = this.content.scrollLeft >= maxScrollLeft - 1;
	}

	prevIndex() {
		// scroll to previous by one card width
		const cardWidth = this.items[ 0 ]?.offsetWidth || 0;
		const gap = parseInt( window.getComputedStyle( this.content ).gap, 10 ) || 0;
		const scrollAmount = cardWidth + gap;

		this.content.scrollBy( {
			left: -scrollAmount,
			behavior: 'smooth',
		} );
	}

	nextIndex() {
		// scroll to next by one card width
		const cardWidth = this.items[ 0 ]?.offsetWidth || 0;
		const gap = parseInt( window.getComputedStyle( this.content ).gap, 10 ) || 0;
		const scrollAmount = cardWidth + gap;

		this.content.scrollBy( {
			left: scrollAmount,
			behavior: 'smooth',
		} );
	}
}

document.querySelectorAll( '.card-slider' ).forEach( ( node ) => {
	new Slider( node, { ...node.dataset } );
} );
